import { API } from "aws-amplify";

import { getAPIReq } from "data/libs/authLib";

export const getProcessesAndWorkflowsWithNoProcess = async (
  hubId,
  includeStats = true
) => {
  const req = await getAPIReq(
    {
      query: `query getProcesses {
      processes(includeStats: ${includeStats}) {
        edges {
          node {
            uuid
            id
            name
            description
            color
            numWorkflows
            numRed
            numGreen
            numYellow
            numActiveClients
            numActiveClientWorkflows
            numAccessList
            template {
              id
              current {
                id
                gated
                public
              }
            }
            workflows {
              edges {
                node {
                  uuid
                  name
                  numTasks
                  numActiveClients
                  numActiveClientWorkflows(limit: 8, includeStats: ${includeStats})
                  hasWorkflowRules
                  isNewTemplate
                  canEdit
                  clientTileOptions {
                    showProgress
                    showIcons
                    showStreams
                    numberOfTasks
                    presentWorkflowName
                    presentStartDate
                  }
                  process {
                    uuid
                    color
                    name
                  }
                }
              }
            }
          }
        }
      }
      workflowsWithNoProcess(includeStats: ${includeStats}) {
        edges {
          node {
            uuid
            name
            numTasks
            numActiveClients
            numActiveClientWorkflows(limit: 8, includeStats: ${includeStats})
            hasWorkflowRules
            isNewTemplate
            canEdit
            clientTileOptions {
              showProgress
              showIcons
              showStreams
              numberOfTasks
              presentWorkflowName
              presentStartDate
            }
          }
        }
      }
    }`,
    },
    { hub: hubId }
  );
  const {
    data: { processes, workflowsWithNoProcess },
  } = await API.post("HublyAPI", `/graphql`, req);

  return [
    processes.edges.map(({ node }) => {
      return {
        ...node,
        globalId: node.id,
        id: node.uuid,
        template: node.template,
        workflows: node.workflows.edges.map(({ node: wNode }) => {
          return {
            ...wNode,
            id: wNode.uuid,
            process: wNode.process
              ? { ...wNode.process, id: wNode.process.uuid }
              : null,
          };
        }),
      };
    }),
    workflowsWithNoProcess.edges.map(({ node }) => {
      return {
        ...node,
        id: node.uuid,
      };
    }),
  ];
};

export default getProcessesAndWorkflowsWithNoProcess;
